import { createAction, props } from '@ngrx/store';

// Models
import { Task } from "src/app/shared/model/task";
import { TaskCategory } from "src/app/shared/model/taskCategory";
import { DataWithName } from "src/app/modules/shared/model/dataWithName";

// Actions for Tasks
export const getTasks = createAction('[TASKS] - GET_TASKS');
export const beginGetTasks = createAction('[TASKS] - BEGIN_GET_TASKS');
export const successGetTasks = createAction('[TASKS] - SUCCESS_GET_TASKS', props<{ payload: Task[] }>());
export const errorTasks = createAction('[TASKS] - Error', props<any>());

// Actions for Task Statuses
export const getTaskStatuses = createAction('[TASK_STATUSES] - GET_TASK_STATUSES');
export const beginGetTaskStatuses = createAction('[TASK_STATUSES] - BEGIN_GET_TASK_STATUSES');
export const successGetTaskStatuses = createAction('[TASK_STATUSES] - SUCCESS_GET_TASK_STATUSES', props<{ payload: any[] }>());
export const errorTaskStatuses = createAction('[TASK_STATUSES] - Error', props<any>());

// Actions for Task Categories
export const getTaskCategories = createAction('[TASK_CATEGORIES] - GET_TASK_CATEGORIES');
export const beginGetTaskCategories = createAction('[TASK_CATEGORIES] - BEGIN_GET_TASK_CATEGORIES');
export const successGetTaskCategories = createAction('[TASK_CATEGORIES] - SUCCESS_GET_TASK_CATEGORIES', props<{ 
    payload: TaskCategory[] }>());
export const errorTaskCategories = createAction('[TASK_CATEGORIES] - Error', props<any>());

// Actions for Task Modules
export const getTaskModules = createAction('[TASK_MODULES] - GET_TASK_MODULES');
export const beginGetTaskModules = createAction('[TASK_MODULES] - BEGIN_GET_TASK_MODULES');
export const successGetTaskModules = createAction('[TASK_MODULES] - SUCCESS_GET_TASK_MODULES', props<{ payload: any[] }>());
export const errorTaskModules = createAction('[TASK_MODULES] - Error', props<any>());

// Actions for Account Names
export const getAccountNames = createAction('[ACCOUNT_NAMES] - GET_ACCOUNT_NAMES');
export const beginGetAccountNames = createAction('[ACCOUNT_NAMES] - BEGIN_GET_ACCOUNT_NAMES');
export const successGetAccountNames = createAction('[ACCOUNT_NAMES] - SUCCESS_GET_ACCOUNT_NAMES', props<{ payload: DataWithName[] }>());
export const errorAccountNames = createAction('[ACCOUNT_NAMES] - Error', props<any>());

// Actions for Lead Names
export const getLeadNames = createAction('[LEAD_NAMES] - GET_LEAD_NAMES');
export const beginGetLeadNames = createAction('[LEAD_NAMES] - BEGIN_GET_LEAD_NAMES');
export const successGetLeadNames = createAction('[LEAD_NAMES] - SUCCESS_GET_LEAD_NAMES', props<{ payload: DataWithName[] }>());
export const errorLeadNames = createAction('[LEAD_NAMES] - Error', props<any>());

// Actions for Opportunity Names
export const getOpportunityNames = createAction('[OPPORTUNITY_NAMES] - GET_OPPORTUNITY_NAMES');
export const beginGetOpportunityNames = createAction('[OPPORTUNITY_NAMES] - BEGIN_GET_OPPORTUNITY_NAMES');
export const successGetOpportunityNames = createAction('[OPPORTUNITY_NAMES] - SUCCESS_GET_OPPORTUNITY_NAMES', props<{ 
    payload: DataWithName[] }>());
export const errorOpportunityNames = createAction('[OPPORTUNITY_NAMES] - Error', props<any>());

// Actions for Case Names
export const getCaseNames = createAction('[CASE_NAMES] - GET_CASE_NAMES');
export const beginGetCaseNames = createAction('[CASE_NAMES] - BEGIN_GET_CASE_NAMES');
export const successGetCaseNames = createAction('[CASE_NAMES] - SUCCESS_GET_CASE_NAMES', props<{ payload: DataWithName[] }>());
export const errorCaseNames = createAction('[CASE_NAMES] - Error', props<any>());

// Actions for Reminder Types
export const getReminderTypes = createAction('[REMINDER_TYPES] - GET_REMINDER_TYPES');
export const beginGetReminderTypes = createAction('[REMINDER_TYPES] - BEGIN_GET_REMINDER_TYPES');
export const successGetReminderTypes = createAction('[REMINDER_TYPES] - SUCCESS_GET_REMINDER_TYPES', props<{ payload: any[] }>());
export const errorReminderTypes = createAction('[REMINDER_TYPES] - Error', props<any>());